import React from 'react';
import { imgStoragePath } from '../../constants';
const InfoIcon = (props) => {
  return(
    <img style={{width: '13px', marginLeft: '4px', cursor: 'pointer'}} id={props.id} src={props.url ? props.url : imgStoragePath+"inv_info_icon.png"} alt="info" />
  )
}
export default InfoIcon;
